// Row-sized shell for an open inline add-task input.
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

/**
 * Dashed-row height, border and leading + icon so the input reads as a sibling
 * of the task rows around it instead of a bare textfield.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 */
export function AddTaskInputRow({ children, className }) {
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        py: 2,
        px: 2.5,
        mb: 1.5,
        minHeight: 48,
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'grey.200',
        borderLeftColor: 'grey.300',
        borderRadius: 'var(--border-radius-sm)',
      }}
    >
      <AddIcon sx={{ fontSize: 14, color: 'text.subtle', flexShrink: 0 }} />
      {children}
    </Box>
  );
}
